import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';
import { getStripeSecretKey } from "./stripeActions";


export function getLoggedInUserSuccess(user) {
  return { type: types.GET_LOGGED_IN_USER_SUCCESS, user };
}

export function getLoggedInUserError() {
  return { type: types.GET_LOGGED_IN_USER_ERROR };
}

export function getUserLocationSuccess(data) {
  return { type: types.GET_USER_LOCATION_SUCCESS, data };
}

export function isUserCoachSuccess(bool) {
  return { type: types.IS_USER_COACH_SUCCESS, bool };
}

export function isUserPlayerSuccess(bool) {
  return { type: types.IS_USER_PLAYER_SUCCESS, bool };
}

export function getUserSignupDetailsSuccess(data) {
  return { type: types.GET_USER_SIGNUP_DETAILS_SUCCESS, data };
}

export function updateEmailSuccess(newEmail) {
  return { type: types.UPDATE_EMAIL_SUCCESS, newEmail };
}

export function updatePhoneNumberSuccess(areaNo1, areaCode1, telNo1) {
  return { type: types.UPDATE_PHONE_NUMBER_SUCCESS, areaNo1, areaCode1, telNo1 };
}

export function updateEmailPreferencesSuccess(emailPreferences) {
  return { type: types.UPDATE_EMAIL_PREFERENCES_SUCCESS, emailPreferences };
}

export function updateCoachAgePreferencesSuccess(agePreferences) {
  return { type: types.UPDATE_COACH_AGE_PREFERENCES_SUCCESS, agePreferences };
}

export function getAccountDetailsSuccess(data) {
  return { type: types.GET_ACCOUNT_DETAILS_SUCCESS, data };
}

export function getLoggedInUser() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/user`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(getLoggedInUserSuccess(res.data));
    }))
    .catch(() => {
      dispatch(getLoggedInUserError());
    });
  };
}

export function getUserLocation() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/user-location`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(getUserLocationSuccess(res.data));
    }))
    .catch((error) => {
      throw error;
    });
  };
}

export function isUserCoach() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/user/is-coach`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(isUserCoachSuccess(res.data.valid));
    }))
    .catch((error) => {
      throw error;
    });
  };
}

export function isUserPlayer() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/user/is-player`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `applicateion/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(isUserPlayerSuccess(res.data.valid));
    }))
    .catch((error) => {
      throw error;
    });
  };
}

export function updatePlan(plan, quantity, discountCode, successUrl, cancelUrl) {
  const item = {};
  item.plan = plan;
  item.quantity = quantity;
  item.discount_code = discountCode;
  item.success_url = successUrl;
  item.cancel_url = cancelUrl;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/payments/update-plan`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      return handleErrors(response);
    })
    .then((response) => {
      return response.json();
    })
    .then((response) => { // Not sure how to lint this as our arrow function will only redirect, not return
      const sessionId = response.data.session_id || null;
      if (sessionId !== null) {
        return dispatch(getStripeSecretKey()).then((key) => {
          const stripe = Stripe(key);
          stripe.redirectToCheckout({ sessionId }).then(() => {
            // Checkout errors are passed to "then" not "catch"
          });
        });
      } 
      if (response.data.action_required === true) {
        window.location.href = `/account/billing/payment-history`;
      } else {
        dispatch(addNotification({
          message: response.message,
          level: `success`,
          autoDismiss: 0,
        }));
      }
      return false;
    })
        .catch(response => response.json().then((res) => {
          dispatch(addNotification({
            message: res.message,
            level: `error`,
            autoDismiss: 0,
          }));
          throw res;
        }));
  };
}


export function updateCardOld(token) {
  const item = {};
  item.token = token;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/payments/update-card`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then(res => (res)))
    .catch(response => response.json().then((res) => {
      dispatch(addNotification({
        message: res.message,
        level: `error`,
        autoDismiss: 0,
      }));
      throw res;
    }));
  };
}

export function planMoveDirection(currentPlan, newPlan) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/payments/plan-move-direction?new_plan=${newPlan}&current_plan=${currentPlan}`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(response => response.json().then(res => (res)))
    .catch(response => response.json().then((res) => {
      dispatch(addNotification({
        message: res.message,
        level: `error`,
        autoDismiss: 0,
      }));
      throw res;
    }));
  };
}

export function updateEmail(newEmail, confirmNewEmail) {
  const item = {};
  item.new_email = newEmail;
  item.confirm_email = confirmNewEmail;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/user/profile/email-address`, {
      method: `PUT`,
      body: JSON.stringify(item),
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        if (res.statusCode === 200) {
          dispatch(updateEmailSuccess(newEmail));
          dispatch(addNotification({
            message: `Your email has been changed.`,
            level: `success`,
            autoDismiss: 0,
          }));
        } else {
          dispatch(addNotification({
            message: res.message,
            level: `error`,
            autoDismiss: 0,
          }));
        }
      });
    })
    .catch((error) => {
      if (error.status !== undefined) {
        if (error.status === 409) {
          // Put the updateEmailSuccess here to stop the wheel of doom
          dispatch(updateEmailSuccess(newEmail));
          // Set the level to "warning" so the colour will make CH sick,
          // look at the code then ask me about it at which point I will
          // have forgotten all about it.
          dispatch(addNotification({
            message: `That email address is already in use`,
            level: `warning`,
            autoDismiss: 0,
          }));
        } else {
          console.log(`throwing error instead`);
          throw (error);
        }
      }
    });
  };
}

export function updatePassword(currentPassword, newPassword, confirmNewPassword) {
  const item = {};
  item.current_password = currentPassword;
  item.new_password = newPassword;
  item.confirm_new_password = confirmNewPassword;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/user/profile/password`, {
      method: `PUT`,
      body: JSON.stringify(item),
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        if (res.statusCode === 200) {
          dispatch(addNotification({
            message: `Your password has been changed.`,
            level: `success`,
            autoDismiss: 0,
          }));
        } else {
          dispatch(addNotification({
            message: res.message,
            level: `error`,
            autoDismiss: 0,
          }));
        }
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}

export function updatePhoneNumber(areaNo1, areaCode1, telNo1) {
  const item = {};
  item.area_no_1 = areaNo1;
  item.area_code_1 = areaCode1;
  item.tel_no_1 = telNo1;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/user/profile/tel-no`, {
      method: `PUT`,
      body: JSON.stringify(item),
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        if (res.statusCode === 200) {
          dispatch(updatePhoneNumberSuccess(areaNo1, areaCode1, telNo1));
          dispatch(addNotification({
            message: `Your phone number has been updated.`,
            level: `success`,
            autoDismiss: 0,
          }));
        } else {
          dispatch(addNotification({
            message: res.message,
            level: `error`,
            autoDismiss: 0,
          }));
        }
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}

export function updateEmailPreferences(emailPreferences) {
  const item = {};
  item.mail_newsletters = emailPreferences;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/user/profile/email-preferences`, {
      method: `PUT`,
      body: JSON.stringify(item),
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        if (res.statusCode === 200) {
          dispatch(updateEmailPreferencesSuccess(emailPreferences));
          dispatch(addNotification({
            message: `Your email preferences have been updated.`,
            level: `success`,
            autoDismiss: 0,
          }));
        } else {
          dispatch(addNotification({
            message: res.message,
            level: `error`,
            autoDismiss: 0,
          }));
        }
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}

export function updateCoachAgePreferences(agePreferences) {
  const item = {};
  item.ages = agePreferences;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/user/interested-ages`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then((response) => {
      response.json().then((res) => {
        if (res.statusCode === 200) {
          dispatch(updateCoachAgePreferencesSuccess(agePreferences));
          dispatch(addNotification({
            message: `The age groups you coach have been updated.`,
            level: `success`,
            autoDismiss: 0,
          }));
        } else {
          dispatch(addNotification({
            message: res.message,
            level: `error`,
            autoDismiss: 0,
          }));
        }
      });
    })
    .catch((error) => {
      throw (error);
    });
  };
}

export function getAccountDetails() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/user/account-details`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(getAccountDetailsSuccess(res.data));
    }))
    .catch((error) => {
      throw error;
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/userActions.js